module.exports = __webpack_public_path__ + "img/source_sw-bt-more.5d2f69da.png";